<template>
    <div class="card">
        <div class="card-header" v-if="cardHeaderTitle">
            <i v-if="cardHeaderIconClass" class="fa" :class="cardHeaderIconClass"></i>
            <span>{{cardHeaderTitle}}</span>
        </div>
        <div class="card-body">
            <h3 class="card-title" v-if="cardTitle">{{cardTitle}}</h3>
            <slot></slot>
        </div>
    </div>
</template>

<script>
// Require FontAwesome
export default {
    name: "CardView",
    props: {
        cardHeaderTitle: '',
        cardHeaderIconClass: '',
        cardTitle: '',
    }
};
</script>

<style scoped>
    
</style>
